const shouldShowRoundPromotion = ({
  discountRounded,
  departureDatePickerText,
}) => discountRounded !== undefined || Boolean(departureDatePickerText);

export default shouldShowRoundPromotion;
